var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43209",
    "data-name": "Group 43209",
    transform: "translate(6326 -6208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_15540",
    "data-name": "Rectangle 15540",
    transform: "translate(-6326 6208)",
    fill: "rgba(212,216,222,0)",
    stroke: "#d4d8de",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_43214",
    "data-name": "Group 43214",
    transform: "translate(-4487 -11101)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16049",
    "data-name": "Rectangle 16049",
    width: 24,
    height: 24,
    transform: "translate(-1827 17321)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-1825.5 17322.502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37224",
    "data-name": "Path 37224",
    d: "M11.751,21.8a10.373,10.373,0,0,1-5.04-1.27.254.254,0,0,0-.2,0l-3.448.977a1.211,1.211,0,0,1-1.524-1.514l1.035-3.467a.264.264,0,0,0,0-.186A10.5,10.5,0,1,1,14,21.565a11.2,11.2,0,0,1-2.246.234Z",
    transform: "translate(-1.29 -0.8)",
    fill: "#868d97"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43217",
    "data-name": "Group 43217"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3082",
    "data-name": "Ellipse 3082",
    cx: 1.221,
    cy: 1.221,
    r: 1.221,
    transform: "translate(5.333 9.719)",
    fill: "#f7f8f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3083",
    "data-name": "Ellipse 3083",
    cx: 1.221,
    cy: 1.221,
    r: 1.221,
    transform: "translate(9.239 9.719)",
    fill: "#f7f8f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3084",
    "data-name": "Ellipse 3084",
    cx: 1.221,
    cy: 1.221,
    r: 1.221,
    transform: "translate(13.146 9.719)",
    fill: "#f7f8f9"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatCircle);
export default __webpack_public_path__ + "static/media/chat-circle.8df190a122614b25478754933dcbb0c4.svg";
export { ForwardRef as ReactComponent };